var quizQuestions = [
    {
        question: "What type of coverage do you prefer?",
        answers: [
            {
                type: "Sheer",
                content: "Sheer (Powder)",
                value: "sheer"
            },
            {
                type: "Medium to Full",
                content: "Medium to Full (Foundation Stick)",
                value: "medium-to-full"
            },
            {
                type: "Full",
                content: "Full (Matte Finish)",
                value: "full"
            }
        ]
    },
    {
        question: "What type of finish are you looking for?",
        answers: [
            {
                type: "Natural",
                content: "Natural (lightweight even tone)",
                value: "natural"
            },
            {
                type: "Luminous",
                content: "Luminous (a natural radiant glow)",
                value: "luminous"
            },
            {
                type: "Matte",
                content: "Matte (shine-free & smooth)",
                value: "matte"
            }
        ]
    },
    {
        question: "How do you usually apply your foundation?",
        answers: [
            {
                type: "brush",
                content: "With a brush",
                value: "brush"
            },
            {
                type: "sponge",
                content: "With a blender/sponge",
                value: "sponge"
            },
            {
                type: "fingers",
                content: "With my fingers",
                value: "fingers"
            }
        ]
    },
    {
        question: "How do you prep your skin before applying foundation?",
        answers: [
            {
                type: "primer",
                content: "Primer",
                value: "primer"
            },
            {
                type: "serum",
                content: "Serum",
                value: "serum"
            },
            {
                type: "moisturizer",
                content: "Moisturizer",
                value: "moisturizer"
            },
            {
                type: "none",
                content: "I don't prep",
                value: "none"
            }
        ]
    }
  ];
  
  export default quizQuestions;